// import { initPageScale } from "@/utils/pageScale";
export default {
  data() {
    return {
      currentScale: 1
      // scaler: null,
    };
  },
  mounted() {
    // this.scaler = initPageScale(this.$refs.scaleContainer, {
    //   designWidth: 1920,
    //   minScale: 0.1,
    //   debounceDelay: 10,
    // });
    this.initPageScale();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 初始化页面缩放
    initPageScale() {
      this.updateScale();
    },
    // 计算缩放比例
    calculateScale() {
      const designWidth = 1920; // 设计稿宽度
      const windowWidth = window.innerWidth;
      const scale = windowWidth / designWidth;

      // 设置最小缩放比例，避免过小
      return Math.max(scale, 0.1);
    },
    // 更新缩放
    updateScale() {
      const container = this.$refs.scaleContainer;
      if (!container) return;
      const scale = this.calculateScale();
      this.currentScale = scale; // 确保这个值被正确设置

      // 应用缩放变换
      container.style.transform = `scale(${scale})`;

      // 计算居中位置
      const scaledWidth = 1920 * scale;
      const offsetX = (window.innerWidth - scaledWidth) / 2;
      container.style.left = `${Math.max(0, offsetX)}px`;
    },
    // 防抖处理resize事件
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.updateScale();
      }, 10);
    }
  }
};